import { prefix } from './actions';

import { ReduxState } from '../init';
import { CartItem, CartWarnings } from '../../types';

export const loading = (state: ReduxState): boolean => state[prefix].loading;

export const cartId = (state: ReduxState): string =>
  state[prefix].cartId || null;

export const cartItems = (state: ReduxState): CartItem[] =>
  state[prefix].cartItems || [];

export const cartWarnings = (state: ReduxState): CartWarnings | null =>
  state[prefix].cartWarnings || null;

export const paymentWalletPublicKey = (state: ReduxState): string =>
  state[prefix].paymentWalletPublicKey || '';
